




import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import BaseTooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import TextWrapper from '@/modules/shared/components/shared/TextWrapper.vue'

@Component({
  components: {
    TextEllipsis,
    TesTr,
    TesTd,
    DateTooltipped,
    BaseTooltip
  }
})
export default class AdminInvoiceBillingInfoTableRow extends mixins<TesTableRow>(TesTableRow) {

  columnComponents = {
    natural_name: {
      component: TextEllipsis,
      handler: (value) => ({ text: value })
    },
    legal_name: {
      component: TextEllipsis,
      handler: (value) => ({ text: value })
    },
    natural_address: {
      component: TextWrapper,
      handler: (value) => ({ text: value, width: 300 })
    },
    legal_address: {
      component: TextWrapper,
      handler: (value) => ({ text: value })
    }
  }

}
